export default {
  data() {
    return {
      formSize: 'medium',
    };
  },
  methods: {
    updateRouteUrl(query = {}) {
      const { name } = this.$route;
      query = { ...query };
      // 调用 this.$router.replace 路由重复时，报 Navigation Duplicated
      query.t = +new Date();
      // 编码中文
      Object.keys(query).forEach((key) => {
        const value = query[key];
        if (typeof value === 'object') {
          query[key] = encodeURIComponent(JSON.stringify(value));
        } else {
          query[key] = value ? encodeURIComponent(value) : '';
        }
      });

      this.$router.replace({
        name,
        query,
      });
    },
    // 复制文字
    $copyMessage(message, tip = '复制成功') {
      this.$copyText(message).then(() => {
        this.$message({
          message: tip,
          type: 'success',
        });
      }, () => {});
    },
    // 复制文字
    $copyCell(row, column, cell, event) {
      this.$copyMessage(event.target.innerText);
    },
  },
};
